import { render, staticRenderFns } from "./ScheduleEdit.vue?vue&type=template&id=0bff8a0e&scoped=true&"
import script from "./ScheduleEdit.vue?vue&type=script&lang=js&"
export * from "./ScheduleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff8a0e",
  null
  
)

export default component.exports